/**
 * De qué sucursales de EBM se pide el catálogo. Lógica pura (sin import.meta ni
 * localStorage) para poder probarla con `npm test`; branches.ts le pasa el estado.
 *
 * Por qué existe: la API del catálogo devuelve TODA la empresa, y un servicio no trae
 * existencia que filtrar en la web. Los servicios de Spartech Santiago (sucursal en
 * prueba) salían en la web de Santo Domingo. Desde el 2-oct-2026 la API acepta
 * `?branchIds=` y se le dice siempre cuáles.
 */

export interface ScopeBranch {
  key: string;
  ebmBranchIds: number[];
}

/**
 * Listado, categorías, marcas, Arma tu PC: con selector, la sucursal elegida (o la
 * principal si no hay elección válida); sin selector, todas las visibles.
 */
export function listingBranchIds(
  visible: readonly ScopeBranch[],
  picker: boolean,
  storedKey: string | null,
): number[] {
  if (picker) {
    const chosen = visible.find((b) => b.key === storedKey) ?? visible[0];
    return chosen ? [...chosen.ebmBranchIds] : [];
  }
  return visibleBranchIds(visible);
}

/** Ficha de producto: todas las visibles, para seguir mostrando «disponible en otra sucursal». */
export function visibleBranchIds(visible: readonly ScopeBranch[]): number[] {
  return [...new Set(visible.flatMap((b) => b.ebmBranchIds))].sort((a, b) => a - b);
}

/**
 * Agrega `branchIds=…` a una URL que puede traer o no query string. Sin ids no agrega
 * nada (la API devuelve toda la empresa): solo pasa con una sucursal sin `ebmBranchIds`.
 */
export function withBranchIds(url: string, ids: readonly number[]): string {
  if (ids.length === 0) return url;
  const qs = ids.map((id) => `branchIds=${encodeURIComponent(String(id))}`).join('&');
  return url + (url.includes('?') ? '&' : '?') + qs;
}
